import { ReactElement } from 'react'
import Link from 'next/link'
import Image from 'next/image'

export default function ValeuFloatingButton(): ReactElement {
  return (
    <Link href="/valeu" className="valeu-floating-button" title="Valeu! - Programa de Reconhecimento">
      <Image src="/icons/valeu.jpg" alt="Valeu!" width={40} height={40} />
    </Link>
  );
}
